


import { useEffect, useState } from 'react'
import { LoadingIndicator } from '@/core/utils/loading-indicator'
import { useNavigate } from 'react-router-dom'
import { supplierService } from '@/projects/platform/services/account-supplier-service'
import { Gallery } from 'devextreme-react'

type Props = {
  className?: string
  svgIcon?: string
  titleClass?: string
  descriptionClass?: string
  iconClass?: string
  title?: string
  description?: string
}


const RetailersBanner = (props: Props) => {
  const { className, svgIcon, titleClass, descriptionClass, iconClass } = props
  const [data, setData] = useState<any>({});
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoadPanelVisible(true);
    supplierService.getRetailers({})
      .then((response) => {
        
        setData(response.data);
        
        console.log(response.data.concat(response.data.concat(response.data)))
        setLoadPanelVisible(false);
      })
      .catch((e) => {
        console.log(e);
        setLoadPanelVisible(false);
      });
  }, [])

  return (
    <Gallery
    dataSource={data}
    height={75}
    width='100%'
    loop={true}
    initialItemWidth={250}
    showIndicator={false}
    showNavButtons={true}
    focusStateEnabled={false}
    itemRender={(Item)} />
  )
}

function Item(data:any) {
  return (
    <div>
      <img height={75} src={data.logoBase64} />
    </div>
  );
}

export default RetailersBanner;
